import { useEffect } from 'react';

/**
 * SEO Component for dynamic meta tags per page
 * Updates document title and meta tags for better search engine optimization
 */
export default function SEO({ 
  title, 
  description, 
  keywords = '',
  image = 'https://zemaxi.com/images/zemaxi-profile.jpg',
  url = 'https://zemaxi.com',
  type = 'website'
}) {
  useEffect(() => {
    // Update document title
    document.title = title ? `${title} | ZeMaxi` : 'ZeMaxi | Twitch Streamer & Free Streaming Tools Creator';
    
    // Helper function to update or create meta tags
    const updateMetaTag = (selector, attribute, content) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, content);
      } else {
        element = document.createElement('meta');
        const [attr, value] = selector.replace('meta[', '').replace(']', '').split('=');
        element.setAttribute(attr, value.replace(/"/g, ''));
        element.setAttribute(attribute, content);
        document.head.appendChild(element);
      }
    };

    // Update primary meta tags
    if (description) {
      updateMetaTag('meta[name="description"]', 'content', description);
    }
    
    if (keywords) {
      updateMetaTag('meta[name="keywords"]', 'content', keywords);
    }

    // Update Open Graph tags
    updateMetaTag('meta[property="og:title"]', 'content', title || 'ZeMaxi | Twitch Streamer & Free Streaming Tools Creator');
    updateMetaTag('meta[property="og:description"]', 'content', description || 'ZeMaxi is a Twitch streamer and creator of free streaming tools for OBS Studio and Streamer.bot.');
    updateMetaTag('meta[property="og:image"]', 'content', image);
    updateMetaTag('meta[property="og:url"]', 'content', url);
    updateMetaTag('meta[property="og:type"]', 'content', type);

    // Update Twitter tags
    updateMetaTag('meta[property="twitter:title"]', 'content', title || 'ZeMaxi | Twitch Streamer & Free Streaming Tools Creator');
    updateMetaTag('meta[property="twitter:description"]', 'content', description || 'ZeMaxi is a Twitch streamer and creator of free streaming tools for OBS Studio and Streamer.bot.');
    updateMetaTag('meta[property="twitter:image"]', 'content', image);
    updateMetaTag('meta[property="twitter:url"]', 'content', url);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    }

  }, [title, description, keywords, image, url, type]);

  return null; // This component doesn't render anything
}